import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Api } from './../api.module';
import { Injectable } from '@angular/core';
import { map, delay } from 'rxjs/operators';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CompanyService {
  saveSearchProject(req: {
    state: { stateId: any; }; country: { countryId: any; }; projectStage: { //   // vendorForWorkType.push(element.vendorId);
      //   vendorForWorkType[g] = { 'vendor': { 'vendorId': element.vendorId }, 'workType': { 'workTypeId': requestProposalForm.typeOfWork } };
      //   // vendorForWorkType.push('vendor', {vendorId: element.vendorId}, 'workType', { workTypeId: requestProposalForm.typeOfWork });
      //   // vendorForWorkType.push('vendor', { vendorId: element.vendorId });
      //   g++;
      // });
      // console.log('Before Api hitting!!!!!!!1111', vendorForWorkType);
      // const body = {
      //   notes: requestProposalForm.notes,
      //   project: { projectId: requestProposalForm.projectName },
      //   vendorInfraResponse: responseOnVendorAccount,
      //   companyEmail: responseOnVendorEmail,
      //   displayCompanyName: responseOnVendorCompanyName,
      //   // vendorForWorkType: [{ vendor: { vendorId: message }, workType: { workTypeId: requestProposalForm.typeOfWork } }]
      //   // vendorForWorkType: [{ vendor: message, workType: { workTypeId: requestProposalForm.typeOfWork } }]
      //   vendorForWorkType: [vendorForWorkType]
      // };
      projectStageId: any;
    }; company: { companyId: any; }; projectName: string; projectSize: any; workTypeId: any; sector: {
      sectorId: any; // vendorForWorkType.push('vendor', {vendorId: element.vendorId}, 'workType', { workTypeId: requestProposalForm.typeOfWork });
    }; // vendorForWorkType.push('vendor', {vendorId: element.vendorId}, 'workType', { workTypeId: requestProposalForm.typeOfWork });
    // vendorForWorkType.push('vendor', {vendorId: element.vendorId}, 'workType', { workTypeId: requestProposalForm.typeOfWork });
    //   // vendorForWorkType.push('vendor', { vendorId: element.vendorId });
    //   g++;
    // });
    // console.log('Before Api hitting!!!!!!!1111', vendorForWorkType);
    // const body = {
    //   notes: requestProposalForm.notes,
    //   project: { projectId: requestProposalForm.projectName },
    //   vendorInfraResponse: responseOnVendorAccount,
    //   companyEmail: responseOnVendorEmail,
    //   displayCompanyName: responseOnVendorCompanyName,
    //   // vendorForWorkType: [{ vendor: { vendorId: message }, workType: { workTypeId: requestProposalForm.typeOfWork } }]
    //   // vendorForWorkType: [{ vendor: message, workType: { workTypeId: requestProposalForm.typeOfWork } }]
    //   vendorForWorkType: [vendorForWorkType]
    // };
    pages: number; size: number;
  }) {
    throw new Error('Method not implemented.');
  }
  logindata: any;

  constructor(private http: HttpClient) {
  }


  private messageSource = new BehaviorSubject('');
  currentMessage = this.messageSource.asObservable();

  // tslint:disable-next-line: typedef
  changeData(data: any) {
    this.messageSource.next(data);
  }

  private messageSourceRequest = new BehaviorSubject('');
  currentMessageRequest = this.messageSourceRequest.asObservable();

  private workTypeMessageSourceRequest = new BehaviorSubject('');
  currentMessageRequestWorkType = this.workTypeMessageSourceRequest.asObservable();

  private testingSource = new BehaviorSubject('default message');
  testingMessage = this.testingSource.asObservable();

  dataSendToRequestProposalWorkType(data: any) {
    this.workTypeMessageSourceRequest.next(data);
  }

  // tslint:disable-next-line: typedef
  changeMessage(message: string) {
    // console.log('Before In data send  change Message in service', message);
    this.messageSource.next(message);
    // console.log('After In data send to change Message in service', this.messageSource);


  }

  // tslint:disable-next-line: typedef
  dataSendToRequestProposal(data: any) {
    // console.log('Before In data send to request proposal in service', data);
    this.messageSourceRequest.next(data);
    // console.log('After In data send to request proposal in service', this.messageSourceRequest);
  }


  private projectIdData = new BehaviorSubject('');
  projectIdMessage = this.projectIdData.asObservable();

  projectIdDetais(data: any) {
    console.log("project id fetched",data.projectId)
    this.projectIdData.next(data.projectId);
  }

  private sectorIdData = new BehaviorSubject('');
  sectorIdMessage = this.sectorIdData.asObservable();

  sectorIdDetais(data: any) {
    console.log("sector id fetched",data)
    this.sectorIdData.next(data);
  }

  // private requestProposalVendor = new BehaviorSubject('');
  // currentrequestProposalVendor = this.requestProposalVendor.asObservable();


  // tslint:disable-next-line: typedef
  countryDetail() {
    // return this.http.get(Api.GETACTIVECOUNTRYDETAILS).map((response: any) => response);
    return this.http.get(Api.GETACTIVECOUNTRYDETAILS).pipe(map((response: any) => response));
  }

  getCurrentStatus() {
    return this.http.get(Api.CURRENT_STATUS_LIST).pipe(map((response: any) => response));
  }

  getActiveTendering() {
    return this.http
        .get(Api.GET_TENDERING_AUTHORITY_LIST)
        .pipe(map((response: any) => response));
}
getActiveProjectValue() {
    return this.http
        .get(Api.GET_PROJECT_VALUE_LIST)
        .pipe(map((response: any) => response));
}

  saveTeamMembersDetail(data) {
    return this.http.post(Api.SAVETEAMMEMBERSDETAIL, data).pipe(map((response: any) => response));
  }

  updateTeamMembersDetail(data) {
    return this.http.put(Api.UPDATETEAMMEMBERSDETAIL, data).pipe(map((response: any) => response));
  }


  // tslint:disable-next-line: typedef
  getStateDetail(countryId) {
    const body = {
      country: { countryId: countryId }
    };
    return this.http.post(Api.GETACTIVESTATEDETAILSBYCOUNTRYID, body).pipe(map((response: any) => response));
  }

  getActiveTeamMembersDetails() {
    return this.http.get(Api.GETACTIVETEAMMEMBERSDETAILS).pipe(map((response: any) => response));
  }
  getActiveTeamMembersDetailsCompanyId(req) {
    const loginUserId = JSON.parse(localStorage.getItem('loginUserId'));
    return this.http.post(Api.GETACTIVETEAMMEMBERSDETAILSCOMPANYID, req).pipe(map((response: any) => response));
  }

  getEquipmentDetailById(equipmentId): any {
    const body = {
      equipmentId: equipmentId
    };
    return this.http.post(Api.GETEQUIPMENTBYEQUIPMENTID, body).pipe(map((response: any) => response));
  }

  getEquipmentRequimentDetailById(equipmentId): any {
    const body = {
      equipmentId: equipmentId
    };
    return this.http.post(Api.GETEQUIPMENTREQUIREMENTPOSTINGDETAILSBYEQUIPMENTID, body).pipe(map((response: any) => response));
  }

  getActiveRateDetailsByStateId(stateId) {
    const body =
    {
      state: { stateId: stateId }
    };
    return this.http.post(Api.GETACTIVERATEDETAILSBYSTATEID, body).pipe(map((response: any) => response));

  }
  notifyMeData(data) {
    return this.http.post(Api.SAVEEQUIPMENTNOTIFICATIONDETAIL, data).pipe(map((response: any) => response));
  }

  companySector(data) {
    return this.http.post(Api.GETSECTORDETAILSBYCOMPANYID, data).pipe(map((response: any) => response));
  }

  getActiveProjectInsuranceDetails(req) {
    
    return this.http.post(Api.GETACTIVEPROJECTINSURANCEdETAILS, req).pipe(map((response: any) => response));
  }

  getActivePlantesandEquipmentDetails(req) {
   
    return this.http.post(Api.GETACTIVEPLANTSANDEQUIPMENTDETAILS, req).pipe(map((response: any) => response));
  }

  getActiveProjectFinanceDetails(req) {
    
    return this.http.post(Api.GETACTIVEPROJECTFINANCEDETAILS, req).pipe(map((response: any) => response));
  }

  getActiveFinancePlantesandEquipmentDetails(req) {
    
    return this.http.post(Api.GETACTIVEPROJECTPLANTSANDEQUIPMENTEDETAILSBYID, req).pipe(map((response: any) => response));
  }

  // tslint:disable-next-line: typedef
  getAllDocument() {
    const userTypeId = JSON.parse(localStorage.getItem('userTypeId'));
    if (userTypeId == 1) {
      var body =
      {
        type: 0
      };
    } else if (userTypeId == 3) {
      var body =
      {
        type: 4
      };
    }
    else if (userTypeId == 2) {
      {
        var body =
        {
          type: 1
        };
      }
    }

    // getActiveFolderDetailsByType
    return this.http.post(Api.GETACTIVEFORLDERDETAILSBYTYPE, body).pipe(map((response: any) => response));
    // return this.http.get(Api.GET_DOCUMENTS_LIST).pipe(map((response: any) => response));
  }

  getAllActiveVendorsWithPagination(size, index) {
    console.log('getActiveVendorDetails' + '?page=' + index + '&&size=' + size);
    return this.http.get(Api.GETALL_VENDORS + '?page=' + index + '&&size=' + size).pipe(map((response: any) => response));
  }

  getVendorForWorkTypeByProjectOrVendor(data) {
    return this.http.post(Api.GETVENDORFORWORKTYPEBYPROJECTORVENDOR, data).pipe(map((response: any) => response));
  }

  getProjectDetails(param) {
    return this.http.post(Api.GET_PROJECT_DETAILS, param).pipe(map((response: any) => response));
  }
  getActiveProjectDetailsByProjectIdOptimiseAPIForCustomerAndAdmin(param) {
    return this.http.post(Api.getActiveProjectDetailsByProjectIdOptimiseAPIForCustomerAndAdmin, param).pipe(map((response: any) => response));
  }

  updateVendorForWorkType(data){
    return this.http.put(Api.Update_Vendor_ForWorkType, data).pipe(map((response: any) => response));
  }
  getCompanyDetails(param) {
    return this.http.post(Api.GET_COMPANY_DETAIL, param).pipe(map((response: any) => response));

  }
  sendMailAgain(data) {
    return this.http.post(Api.SENDMAILREMINDER, data).pipe(map((response: any) => response));
  }
  // tslint:disable-next-line: typedef
  saveDocument(data) {
    const formData = new FormData();
    formData.append('documentName', data.image);
    formData.append('operatorFlag', data.operatorFlag);
    formData.append('companyFlag', data.companyFlag);
    formData.append('vendorFlag', data.vendorFlag);
    formData.append('folderName', data.folderName);
    console.log(formData);
    return this.http.post(Api.SAVE_DOC, formData).pipe(map((response: any) => response));
  }

  // tslint:disable-next-line: typedef
  getAllProject() {
    return this.http.get(Api.GETACTIVEPROJECTSDETAILS).pipe(map((response: any) => response));
  }

  getActiveStatusDetails() {
    return this.http.get(Api.GETACTIVESTATUSDETAILS).pipe(map((response: any) => response));
  }

  getVendorPercentage() {
    return this.http.get(Api.GET_PERCENTAGE_LIST).pipe(map((response: any) => response));
  }

  // tslint:disable-next-line: typedef
  getActiveWorkTypeDetails() {
    return this.http.get(Api.GETACTIVEWORKTYPEDETAILS).pipe(map((response: any) => response));
  }


  // tslint:disable-next-line: typedef
  getActiveProjectDetailsByCompanyId(data, size, index) {
    // const body = {
    //   company: { companyId: data }
    // };
    return this.http.post(Api.GETACTIVEPROJECTLISTBYCOMPANYID + '?page=' + index + '&&size=' + size, data).pipe(map((response: any) => response));
  }

  getActiveProjectDetailByCompanyId(req) {
    return this.http.post(Api.GETACTIVEPROJECTLISTBYCOMPANYID, req).pipe(map((response: any) => response));
  }
  feedbackSearch(data) {
    // const body = {
    //   startDate: data.startDate,
    //   endDate: data.endDate,
    //   user: { userName: data.username }
    //   // username: "fsdfsdf"
    // };
    return this.http.post(Api.GETINQUIRYDETAILSBYDATESANDUSERNAME, data).pipe(map((response: any) => response));
  }


  // tslint:disable-next-line: typedef
  searchEquipmentList(data) {
    const body = {
      equipmentCategory: { equipmentCategoryId: data.equipmentCategory },
      equipmentSubCategory: { equipmentSubCategoryId: data.equipmentSubCategory },
      zone: { zoneId: data.zone },
      type: data.type,
      availability: { availabilityId: data.availability },
      equipmentName: data.equipmentName
    };
    return this.http.post(Api.GETEQUIPMENTBYCATEGORYSUBCATEGORYZONETYPENAME, body).pipe(map((response: any) => response));
  }

  getShortlistedEquipmentByCategorySubCategoryZoneTypeNameByCompany(data, companyId): any {
    const body = {
      // equipmentCategory: { equipmentCategoryId: data.equipmentCategory },
      // equipmentSubCategory: { equipmentSubCategoryId: data.equipmentSubCategory },
      // zone: { zoneId: data.zone },
      // type: data.type,
      // equipmentName: data.equipmentName,

      company: { companyId: companyId },
      category: data.equipmentCategory,
      subCategory: data.equipmentSubCategory,
      zone: data.zone,
      type: data.type,
      equipmentName: data.equipmentName
    };
    console.log('body for get5 who4t lited ', body);
    return this.http.post(Api.GETSHORTLISTEDEQUIPMENTBYCATEGORYSUBCATEGORYZONETYPENAMEBYCOMPANY, body).pipe(map((response: any) => response));
  }

  getEquipmentByCategorySubCategoryZoneTypeNameByCompany(body): any {
    const loginUserId = JSON.parse(localStorage.getItem('loginUserId'));
    // const body = {
    //   user: {userId : loginUserId},
    //   company: { companyId: companyId },
    //   equipmentCategory: { equipmentCategoryId: data.equipmentCategory },
    //   equipmentSubCategory: { equipmentSubCategoryId: data.equipmentSubCategory },
    //   zone: { zoneId: data.zone },
    //   type: data.type,
    //   equipmentName: data.equipmentName,
    //   availabilityId: data.availability,
    //   pages: 0,
    //   size: 12

    // };
    return this.http.post(Api.GETEQUIPMENTBYCATEGORYSUBCATEGORYZONETYPENAMEBYCOMPANY, body).pipe(map((response: any) => response));
  }

  // tslint:disable-next-line: typedef
  // saveRequestProposalDetail(requestProposalForm, responseOnVendorAccount,
  //   responseOnVendorEmail, responseOnVendorCompanyName, message)
  saveRequestProposalDetail(data) {
    // console.log('requestProposalForm service', requestProposalForm);
    // console.log('responseOnVendorAccount service', responseOnVendorAccount);
    // console.log('responseOnVendorEmail service', responseOnVendorEmail);
    // console.log('responseOnVendorCompanyName service', responseOnVendorCompanyName);
    // console.log('message service', message);


    // const vendorForWorkType = {};
    // var g = 0;
    // message.forEach(element => {
    //   console.log('element!!!!!', element);
    //   // vendorForWorkType['vendor']['vendorId']['vendorId']=element.vendorId;
    //   // vendorForWorkType['vendor']['workType']['workTypeId']=requestProposalForm.typeOfWork;
    //   // vendorForWorkType.push(element.vendorId);
    //   vendorForWorkType[g] = { 'vendor': { 'vendorId': element.vendorId }, 'workType': { 'workTypeId': requestProposalForm.typeOfWork } };
    //   // vendorForWorkType.push('vendor', {vendorId: element.vendorId}, 'workType', { workTypeId: requestProposalForm.typeOfWork });
    //   // vendorForWorkType.push('vendor', { vendorId: element.vendorId });
    //   g++;
    // });
    // console.log('Before Api hitting!!!!!!!1111', vendorForWorkType);


    // const body = {
    //   notes: requestProposalForm.notes,
    //   project: { projectId: requestProposalForm.projectName },
    //   vendorInfraResponse: responseOnVendorAccount,
    //   companyEmail: responseOnVendorEmail,
    //   displayCompanyName: responseOnVendorCompanyName,
    //   // vendorForWorkType: [{ vendor: { vendorId: message }, workType: { workTypeId: requestProposalForm.typeOfWork } }]
    //   // vendorForWorkType: [{ vendor: message, workType: { workTypeId: requestProposalForm.typeOfWork } }]
    //   vendorForWorkType: [vendorForWorkType]
    // };

    return this.http.post(Api.SAVEREQUESTPROPOSALDETAIL, data).pipe(map((response: any) => response));
    // console.log('After Api hitting');
  }

  // tslint:disable-next-line: typedef
  getActiveEquipmentSubCategoryDetailsByEquipCate(event) {
    const body = {
      equipmentCategory: { equipmentCategoryId: event }

    };
    return this.http.post(Api.GETACTIVEEQUIPMENTSUBCATEGORYDETAILSBYEQUIPMENTCATEGORY, body).pipe(map((response: any) => response));
  }



  getVendorStatus() {
    return this.http.get(Api.GET_STATUS_VENDOR).pipe(map((response: any) => response));
  }


  // // tslint:disable-next-line: typedef
  // changeRequestProposals(data: any) {
  //   this.requestProposalVendor.next(data);
  // }

  // tslint:disable-next-line: typedef
  projectDetail() {
    return this.http.get(Api.GETACTIVEPROJECTTYPEDETAILS).pipe(map((response: any) => response));
  }

  getActiveCompanySizeDetails() {
    return this.http.get(Api.GETACTIVECOMPANYSIZEDETAILS).pipe(map((response: any) => response));
  }
  // // tslint:disable-next-line: typedef
  // sectorDetail() {

  //   const promise = 
  //   this.http.get(Api.GETACTIVESECTORDETAILS).toPromise();
  //   console.log('promise', promise);
  //   promise.then((data) => {
  //     console.log("Promise resolved with", JSON.stringify(data));

  //   }, (error) => {
  //     console.log("Promise rejected with", JSON.stringify(error));
  //   });
  //   // return this.http.get(Api.GETACTIVESECTORDETAILS).pipe(map((response: any) => response));
  // }


  projectWorkTypeWise(data) {
    const body = {
      projectId: data
    };
    console.log(body);
    return this.http.post(Api.GETWORKTYPEBYPROJECTID, body).pipe(map((response: any) => response));

  }

  sectorDetail() {
    console.log('Sector detail in service in 181');
    return this.http.get(Api.GETACTIVESECTORDETAILS).pipe(map((response: any) => response));
  }

  activeProjectStages() {
    return this.http.get(Api.ACTIVE_PROJECT_STAGE).pipe(map((response: any) => response));
  }

  // ---------------------------------------------------------------------------------------------------------
  getEquipmentRequirementDetailById(equipmentId): any {
    const body = {
      equipmentId: equipmentId
    };
    return this.http.post(Api.GETEQUIPMENTREQUIREMENTPOSTINGDETAILSBYEQUIPMENTID, body).pipe(map((response: any) => response));
  }
  // -----------------------------------------------------------------------------------------------------------

  updatePlantsAndEquipmentsRequirement(data) {
    return this.http.put(Api.UPDATE_EQUIPMENT_REQUIREMENTS, data).pipe(map((response: any) => response));
  }

  // tslint:disable-next-line: typedef
  projectStageDetail() {
    return this.http.get(Api.GETACTIVEPROJECTSSTAGEDETAILS).pipe(map((response: any) => response));
  }

  // tslint:disable-next-line: typedef
  getWorkUndertakenBySector(data) {
    console.log('data for  work', data);
    const body = {
      sector: { sectorId: data }
    };
    console.log(body);
    return this.http.post(Api.GETACTIVEWORKTYPEDETAILSBYSECTOR, body).pipe(map((response: any) => response));
  }

  
  getActiveSectorIntelligenceDetailsBySector(data) {
    console.log('data for  work', data);
    const body = {
      sector: { sectorId: data }
    };
    console.log(body);
    return this.http.post(Api.GETACTIVESECTORINTELLIGENCEDETAILSBYSECTTOR, body).pipe(map((response: any) => response));

  }

  saveFeedBack(data) {
    const loginUserId = JSON.parse(localStorage.getItem('loginUserId'));
    const body = {
      title: data.title,
      description: data.description,
      mobile: data.mobile,
      contactPerson: data.contactPerson,
      user: { userId: loginUserId },
      status: "0",
      statusDescription: null
    };
    return this.http.post(Api.SAVEINQUIRYDETAIL, body).pipe(map((response: any) => response));


  }

  saveEmailFeedback(data) {
    return this.http.post(Api.SAVEINQUIRYDETAIL, data).pipe(map((response: any) => response));
  }

  sendDomainRequest(data) {
    return this.http.post(Api.SAVEINQUIRYDETAILDOMAIN, data).pipe(map((response: any) => response));
  }

  // tslint:disable-next-line: typedef
  projectAdd(fd) {

    // console.log('files in  project add service', files);

    // const fd = new FormData();
    // // 'projectType': { 'projectTypeId': dataProject.projectType }
    // fd.append('company', companyId);
    // fd.append('projectName', dataProject.projectName);
    // fd.append('projectSize', dataProject.projectSize);
    // fd.append('duration', dataProject.duration);
    // fd.append('projectDescription', dataProject.projectDescription);
    // fd.append('flag', dataProject.flag);
    // fd.append('projectLocation', dataProject.location);
    // fd.append('country', dataProject.country);
    // fd.append('projectType', dataProject.projectType);
    // fd.append('listingDate', dataProject.listingDate);
    // fd.append('endDate', dataProject.endDate);
    // fd.append('expiryDate', dataProject.expiryDate);
    // fd.append('projectStage', dataProject.projectStage);
    // fd.append('workType', typeOfWork);
    // fd.append('files', files);
    // fd.append('location', dataProject.location);


    // const body = {
    //   projectName: dataProject.projectName,
    //   projectSize: dataProject.projectSize,
    //   duration: dataProject.duration,
    //   listingDate: dataProject.listingDate,
    //   endDate: dataProject.endDate,
    //   expiryDate: dataProject.expiryDate,
    //   projectStage: {
    //     projectStageId: dataProject.projectStage
    //   },
    //   projectLocation: dataProject.location,
    //   projectType: { projectTypeId: dataProject.projectType },
    //   country: { countryId: dataProject.country },
    //   workType: { workTypeId: typeOfWork },
    //   flag: dataProject.flag,
    //   files: files,
    //   location: { locationId: dataProject.location },
    //   projectDescription: dataProject.projectDescription
    // };

    console.log('filessssssssssssssss', fd);
    return this.http.post(Api.SAVEPROJECTDETAIL, fd).pipe(map((response: any) => response));
  }


  // tslint:disable-next-line: typedef
  // projectEditForm(dataProject, projectId, typeOfWork) {
  projectEditForm(body) {
    // const body = {
    //   projectId: projectId,
    //   projectName: dataProject.projectName,
    //   projectSize: dataProject.projectSize,
    //   duration: dataProject.duration,
    //   listingDate: dataProject.listingDate,
    //   endDate: dataProject.endDate,
    //   location: dataProject.location,
    //   projectType: { projectTypeId: dataProject.projectType },
    //   country: { countryId: dataProject.country },
    //   worktype: { workTypeId: typeOfWork },
    // };



    return this.http.put(Api.UPDATEPROJECT, body).pipe(map((response: any) => response));
    // return this.http.put(Links.UPDATEPROJECT, body).map((response: any) => response);
  }

  // tslint:disable-next-line: typedef
  deleteProject(projectId) {

    const options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      body: {
        projectId: projectId
      }
    };
    return this.http.delete(Api.DELETEPROJECT, options).pipe(map((response: any) => response));
  }

  deleteTeamMember(data) {

    const options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      body: {
        teamMembersId: data.teamMembersId
      }
    };
    return this.http.delete(Api.DELETETEAMMEMBERS, options).pipe(map((response: any) => response));
  }

  getAllCompanyName() {
    return this.http.get(Api.GETACTIVECOMPANYDETAILS).pipe(map((response: any) => response));

  }

  getCompanyDetailByUserId(req) {
    return this.http.post(Api.GET_COMPANY_DETAIL, req).pipe(map((response: any) => response));
  }


  // tslint:disable-next-line: typedef
  companyDetail() {
    return this.http.get(Api.GET_ALL_COMPANY_NAME).pipe(map((response: any) => response));
    // return this.http.get(Api.GETACTIVECOMPANYDETAILS).map((response: any) => response);
  }

  getFolderData(data) {
    return this.http.post(Api.GET_ACTIVE_DOCUMENT_DETAIL_BY_PARENT_ID, data).pipe(map((response: any) => response));
  }

  // tslint:disable-next-line: typedef
  locationDetail() {
    return this.http.get(Api.GETACTIVELOCATIONDETAILS).pipe(map((response: any) => response));
    // return this.http.get(Links.GETACTIVELOCATIONDETAILS).map((response: any) => response);
  }

  // tslint:disable-next-line: typedef   
  companyDetailByType() {
    return this.http.get(Api.GETACTIVECOMPANYTYPEDETAILS).pipe(map((response: any) => response));
  }

  searcData(data) {
    return this.http.post(Api.HOME_PAGE_DOCUMENT_REPO_SEARCH, data).pipe(map((response: any) => response));
  }

  // tslint:disable-next-line: typedef
  getCompanyDetail(userId) {
    const body = {
      user: { userId: userId }
    };
    return this.http.post(Api.GETACTIVECOMPANYDETAILSBYUSERID, body).pipe(map((response: any) => response));

  }

  // tslint:disable-next-line: typedef
  getEquipmentDetailByUserId(userId) {
    const body = {
      user: { userId: userId }
    };
    return this.http.post(Api.GETACTIVECOMPANYDETAILSBYUSERID, body).pipe(map((response: any) => response));

  }

  // tslint:disable-next-line: typedef
  getCompanyDetailForProfile(userId) {
    const body = {
      user: { userId: userId }
    };
    return this.http.post(Api.GETACTIVECOMPANYTEMPDETAILSBYUSERID, body).pipe(map((response: any) => response));
  }

  // tslint:disable-next-line: typedef
  saveEquipmentShortlistedDetail(companyId) {
    const body = {
      company: { companyId: companyId }
    };
    return this.http.post(Api.GETEQUIPMENTSHORTLISTEDBYCOMPANYID, body).pipe(map((response: any) => response));
  }

  saveEquipmentShortlistedDetailByUserId(userId, index, size) {
    const body = {
      user: { userId: userId }
    };
    return this.http.post(Api.GETEQUIPMENTSHORTLISTEDBYCOMPANYID + '?page=' + index + '&&size=' + size, body).pipe(map((response: any) => response));
  }

  getTendorDetailsbyID(data) {
   
    return this.http.post(Api.GET_TENDOR_DETAILSBY_ID, data).pipe(map((response: any) => response));
  }

  // tslint:disable-next-line: typedef
  deleteEquipmentShortListed(companyId, equipmentId) {
    // const body = {
    //   company: { companyId: companyId },
    //   equipmentShortlistedId: equipmentId
    // };  

    const options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      body: {
        company: { companyId: companyId },
        equipmentShortlistedId: equipmentId
      }
    };

    console.log('options for delete equipent shortlisted', options);


    return this.http.delete(Api.DELETEEQUIPMENTSHORTLISTED, options).pipe(map((response: any) => response));
  }

  getEquipmentByCompanyId(companyId) {
    const body = {
      company: { companyId: companyId }
    };
    return this.http.post(Api.GETEQUIPMENTBYCOMPANYID, body).pipe(map((response: any) => response));
  }

  getEquipmentByUserId(userId, index, size) {
    const body = {
      user: { userId: userId }
    };
    return this.http.post(Api.GETEQUIPMENTBYCOMPANYID + '?page=' + index + '&&size=' + size, body).pipe(map((response: any) => response));
  }

  getEquipmentRequirementByUserId(userId, index, size) {
    const body = {
      user: { userId: userId }
    };
    return this.http.post(Api.GETEQUIPMENTREQUIREMENTBYCOMPANYID + '?page=' + index + '&&size=' + size, body).pipe(map((response: any) => response));
  }
  getAllEquipmentRequirement(index, size) {
    
    return this.http.get(Api.GETALLEQUIPMENTREQUIREMENT + '?page=' + index + '&&size=' + size).pipe(map((response: any) => response));
  }

  viewDetail(row) {
    const body = {
      vendor: { vendorId: row.vendorId }
    };
    return this.http.post(Api.SAVEVENDORVISITDETAIL, body).pipe(map((response: any) => response));
  }

  getActiveProjectsByCompanyId(companyid) {
    const body = {
      company: { companyId: companyid }
    };
    return this.http.post(Api.GETACTIVEPROJECTDETAILSBYCOMPANYID, body).pipe(map((response: any) => response));
    // //////////////////////////////////////////////////////////////
  }
  getActiveProjectsByCompanyIdWithoutPagable(companyid) {
    const body = {
      company: { companyId: companyid }
    };
    return this.http.post(Api.GETACTIVEPROJECTDETAILSBYCOMPANYIDWITHOUTPAGABLE, body).pipe(map((response: any) => response));
    // //////////////////////////////////////////////////////////////
  }
  getAllProjectPagination(size, index) {
    return this.http.get(Api.GETACTIVEPROJECTLISTFORVENDORSEARCHMODULE + '?page=' + index + '&&size=' + size).pipe(map((response: any) => response));
  }

  // tslint:disable-next-line: typedef
  getCompanyDetailsForDashboard(companyId) {
    const body = {
      companyId: companyId
    };
    return this.http.post(Api.GETCOMPANYDASHBOARDDETAILS, body).pipe(map((response: any) => response));
  }

  getListOfCompanyVendorRecommendation() {
    return this.http.get(Api.getListOfCompanyVendorRecommendation).pipe(map((response: any) => response));
  }

  // tslint:disable-next-line: typedef
  profileFormSubmitCompany(data, workType) {
    console.log('data', data);
    // console.log('data project ', data.project);
    // console.log('data project project type', data.project.projetType);
    this.logindata = JSON.parse(localStorage.getItem('loginData'));

    const body = {

      user: { userId: this.logindata.userId },
      gstNo: data.gstNo,
      companyName: data.vCompanyName,
      profile: data.vCompanyProfile,
      size: data.vCompanySize,
      // annualRevenue: data.annualRevenue,
      annualTurnover: { annualTurnoverId: data.annualRevenue },
      contactPerson: data.contactPerson,
      contactNumber: data.contactNumber,
      product: data.product,
      equipment: data.equipment,
      companyType: { companyTypeId: data.companyType },
      aboutUs: data.aboutUs,
      website: data.website,
      establishmentYear: data.establishmentYear,
      // 'location': data.location,
      country: { countryId: data.country },
      state: { stateId: data.state },
      // 'locationPerson': data.locationPerson,
      // 'locationPersonPhone': data.locationPersonPhone,
      // workUndertaken: data.workUndertaken,
      // workType: [{ workTypeId: workType }],
      // workType: { workTypeId: workType },
      workType: workType,
      certification: data.certification,
      awards: data.awards,
      location: [{
        locationName: data.locationName, locationPerson: data.locationPerson, locationPersonPhone: data.locationPersonPhone,
        personEmail: data.personEmail
      }],

    };

    console.log(body);

    // return this.http.post(Links.SAVEVENDORDETAIL, body).map((response: any) => response);
    return this.http.post(Api.SAVECOMPANYDETAIL, body).pipe(map((response: any) => response));
  }

  // tslint:disable-next-line: typedef
  profileUpdateFormSubmit(data, workType, companyId) {
    console.log('data', data);
    // console.log('data project ', data.project);
    // console.log('data project project type', data.project.projetType);
    this.logindata = JSON.parse(localStorage.getItem('loginData'));

    const body = {

      user: { userId: this.logindata.userId },
      gstNo: data.gstNo,
      companyId: companyId,
      companyName: data.vCompanyName,
      profile: data.vCompanyProfile,
      size: data.vCompanySize,
      // annualRevenue: data.annualRevenue,
      annualTurnover: { annualTurnoverId: data.annualRevenue },
      contactPerson: data.contactPerson,
      contactNumber: data.contactNumber,
      product: data.product,
      equipment: data.equipment,
      companyType: { companyTypeId: data.companyType },
      aboutUs: data.aboutUs,
      website: data.website,
      establishmentYear: data.establishmentYear,
      // 'location': data.location,
      country: { countryId: data.country },
      state: { stateId: data.state },
      // 'locationPerson': data.locationPerson,
      // 'locationPersonPhone': data.locationPersonPhone,
      // workUndertaken: data.workUndertaken,
      // workType: [{ workTypeId: workType }],
      // workType: { workTypeId: workType },
      workType: workType,
      certification: data.certification,
      awards: data.awards,
      location: [{
        locationName: data.locationName, locationPerson: data.locationPerson, locationPersonPhone: data.locationPersonPhone,
        personEmail: data.personEmail
      }],

    };

    console.log(body);

    // return this.http.post(Links.SAVEVENDORDETAIL, body).map((response: any) => response);
    return this.http.put(Api.UPDATECOMPANY, body).pipe(map((response: any) => response));


  }


  // tslint:disable-next-line: typedef
  profileUpdateFormSubmitForm(data) {
    console.log('data', data);
    // console.log('data project ', data.project);
    // console.log('data project project types', data.project.projetType);
    this.logindata = JSON.parse(localStorage.getItem('loginUserId'));

    const body = {

      user: { userId: this.logindata },
      companyId: data.companyId,
      gstNo: data.gstNo,
      companyName: data.vCompanyName,
      // profile: data.vCompanyProfile,
      size: data.vCompanySize,
      annualTurnover: { annualTurnoverId: data.annualRevenue },
      contactPerson: data.contactPerson,
      contactNumber: data.contactNumber,
      companyLocation: data.locationName,
      product: data.product,
      equipment: data.equipment,
      companyType: { companyTypeId: data.companyType },
      aboutUs: data.aboutUs,
      website: data.website,
      establishmentYear: data.establishmentYear,
      certification: data.certification,
      awards: data.awards,
      location: data.workType,

    };
    // return this.http.post(Links.SAVEVENDORDETAIL, body).map((response: any) => response);
    return this.http.put(Api.UPDATECOMPANY, data).pipe(map((response: any) => response));


  }

  // tslint:disable-next-line: typedef
  deleteEquipment(data, companyId) {
    const options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      body: {
        equipmentId: data.equipmentId,
        user: { userId: companyId }
      }
    };
    return this.http.delete(Api.DELETEEQUIPMENT, options).pipe(map((response: any) => response));
  }
  // tslint:disable-next-line: typedef
  deleteEquipmentRequirment(data, companyId) {
    const options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      body: {
        equipmentId: data.equipmentId,
        user: { userId: companyId }
      }
    };
    return this.http.delete(Api.DELETEEQUIPMENTREQUIRMENT, options).pipe(map((response: any) => response));
  }
  // tslint:disable-next-line: typedef
  deleteEquipmentShortlisted(data) {

    const options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      body: {
        equipmentShortlistedId: data.equipmentId
      }
    };


    return this.http.delete(Api.DELETEEQUIPMENTSHORTLISTED, options).pipe(map((response: any) => response));
  }

  // // tslint:disable-next-line: typedef
  // saveEquipmentShortListed(equipmentId, companyId) {
  //   const body = {

  //     company: { companyId: companyId},
  //     equipment: { equipmentId: equipmentId}
  //   };

  //   return this.http.post(Api.SAVECOMPANYDETAIL, body).pipe(map((response: any) => response));

  // }

  // tslint:disable-next-line: typedef
  getAllEquipmentsListByUserId(loginUserId, index, size) {
    const body = {
      user: { userId: loginUserId }
    };
    return this.http.post(Api.GET_ALL_EQUIPMENTS_LIST + '?page=' + index + '&&size=' + size, body).pipe(map((response: any) => response));
  }

  getAllEquipmentsRequirementListByUserId(loginUserId, index, size) {
    const body = {
      user: { userId: loginUserId }
    };
    return this.http.post(Api.GET_ALL_EQUIPMENTS_LIST + '?page=' + index + '&&size=' + size, body).pipe(map((response: any) => response));
  }

  // tslint:disable-next-line: typedef
  getAllEquipmentsList(companyId) {
    const body =
    {
      company: { companyId: companyId }
    };
    return this.http.post(Api.GET_ALL_EQUIPMENTS_LIST, body).pipe(map((response: any) => response));
  }

  updateEquipments(data, isActivate) {
    const loginUserId = JSON.parse(localStorage.getItem('loginUserId'));
    const formData = new FormData();
    formData.append('files', data.firstImage);
    formData.append('files', data.secondImage);
    formData.append('files', data.thirdImage);
    formData.append('equipmentId', data.equipmentId);
    // formData.append('company', data.company.companyId);
    formData.append('equipmentCategory', data.equipmentCategory.equipmentCategoryId);
    formData.append('equipmentSubCategory', data.equipmentSubCategory.equipmentSubCategoryId);
    formData.append('equipmentName', data.equipmentName);
    formData.append('make', data.make);
    formData.append('model', data.model);
    formData.append('capacity', data.capacity);
    formData.append('number', data.number);
    formData.append('availability', data.availability.availabilityId);
    formData.append('type', data.type);
    formData.append('title', data.title);
    formData.append('description', data.description);
    formData.append('zone', data.zone.zoneId);
    formData.append('equipmentLocation', data.equipmentLocation);
    formData.append('insurance', data.insurance);
    formData.append('insuranceValidity', data.insuranceValidity);
    formData.append('hypothecation', data.hypothecation);
    formData.append('user', loginUserId);
    formData.append('isActivate', isActivate);
    return this.http.put(Api.UPDATE_EQUIPMENT, formData).pipe(map((response: any) => response));
  }

  // tslint:disable-next-line: typedef
  getZone() {
    return this.http.get(Api.GET_ZONE).pipe(map((response: any) => response));
  }
  // tslint:disable-next-line: typedef
  getEquipmentCategory() {
    return this.http.get(Api.GET_EQUIPMENTS_CATEGORY).pipe(map((response: any) => response));
  }
  // tslint:disable-next-line: typedef
  getEquipmentSubCategory() {
    return this.http.get(Api.GET_EQUIPMENTS_SUB_CATEGORY).pipe(map((response: any) => response));
  }

  // tslint:disable-next-line: typedef
  getOwnershipData() {
    return this.http.get(Api.GET_OWNERSHIP_TYPE).pipe(map((response: any) => response));
  }

  // tslint:disable-next-line: typedef
  getAvailableFor() {
    return this.http.get(Api.GET_AVAILABLE_FOR).pipe(map((response: any) => response));
  }
  getrequiredFor() {
    return this.http.get(Api.GET_AVAILABLE_FOR).pipe(map((response: any) => response));
  }

  // tslint:disable-next-line: typedef
  getSubCategoryByCategoryId(data) {
    return this.http.post(Api.GET_SUB_CATEGORY_BY_CATEGORY_ID, data).pipe(map((response: any) => response));
  }

  // tslint:disable-next-line: typedef
  savePlantsAndEquipments(data) {
    // console.log('FileData in service', fileData);

    // const formData = new FormData();
    // formData.append('company', companyId);
    // formData.append('equipmentCategory', data.equipmentCategory);
    // formData.append('equipmentSubCategory', data.equipmentSubCategory);
    // formData.append('equipmentName', data.equipmentName);
    // formData.append('make', data.make);
    // formData.append('model', data.model);
    // formData.append('capacity', data.capacity);
    // formData.append('number', data.nos);
    // formData.append('availability', data.availability);
    // formData.append('type', data.ownershipType);
    // formData.append('title', data.title);
    // formData.append('description', data.description);
    // formData.append('zone', data.zone);
    // formData.append('equipmentLocation', data.equipmentLocation);
    // formData.append('insurance', data.insurance);
    // formData.append('insuranceValidity', data.insuranceValidity);
    // formData.append('hypothecation', data.hypothecation);
    // formData.append('files', fileData);

    // console.log('formData', formData);

    return this.http.post(Api.SAVE_EQUIPMENT_AND_PANTS, data).pipe(map((response: any) => response));
  }

  savePlantsAndEquipmentsRequirement(data) {
    return this.http.post(Api.SAVE_EQUIPMENT_REQUIREMENTS, data).pipe(map((response: any) => response));
  }

  // tslint:disable-next-line: typedef
  updatePlantsAndEquipments(data) {
    console.log('formData', data);

    return this.http.put(Api.UPDATE_EQUIPMENT_AND_PANTS, data).pipe(map((response: any) => response));
  }



  // tslint:disable-next-line: typedef
  shortListMyEquipment(companyId, equipmentId) {
    const body = {
      company: { companyId: companyId },
      equipment: { equipmentId: equipmentId }
    };
    return this.http.post(Api.SAVEEQUIPMENTSHORTLISTEDDETAILFORALL, body).pipe(map((response: any) => response));
  }

  shortListMyEquipmentByUserId(userId, equipmentId) {
    const body = {
      user: { userId: userId },
      equipment: { equipmentId: equipmentId }
    };
    return this.http.post(Api.SAVEEQUIPMENTSHORTLISTEDDETAILFORALL, body).pipe(map((response: any) => response));
  }
  // tslint:disable-next-line: typedef
  deleteEquipmentShortlistedForAll(companyId, equipmentId) {

    const options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      body: {
        equipmentShortlistedId: equipmentId,
        company: { companyId: companyId }
      }
    };

    // const body = {
    //   equipmentShortlistedId: equipmentId,
    //   company: { companyId: companyId }
    // };
    return this.http.delete(Api.DELETEEQUIPMENTSHORTLISTEDFORALL, options).pipe(map((response: any) => response));
  }



  saveRatingForm(data) {
    const loginUserId = JSON.parse(localStorage.getItem('loginUserId'));
    return this.http.post(Api.SAVERATINGDETAIL, data).pipe(map((response: any) => response));
  }


  // tslint:disable-next-line: typedef
  searchEquipments(data) {
    return this.http.post(Api.SEARCH_EQUIPMENTS, data).pipe(map((response: any) => response));
  }

  getActiveA3YGrowthDetails() {
    return this.http.get(Api.GETACTIVEA3YGROWTHDETAILS).pipe(map((response: any) => response));
  }

  getActiveASWGrowthDetails() {
    return this.http.get(Api.GETACTIVEASWGROWTHDETAILS).pipe(map((response: any) => response));
  }

  getActiveFundBaseBankLimitDetails() {
    return this.http.get(Api.GETACTIVEFUNDBASEBANKLIMITDETAILS).pipe(map((response: any) => response));
  }

  getActiveNonFundBaseBankLimitDetails() {
    return this.http.get(Api.GETACTIVENONFUNDBASEBANKLIMITDETAILS).pipe(map((response: any) => response));
  }

  getActiveBankRatingDetails() {
    return this.http.get(Api.GETACTIVEBANKRATINGDETAILS).pipe(map((response: any) => response));
  }

  getActiveDebtEquityRatioDetails() {
    return this.http.get(Api.GETACTIVEDEBTEQUITYRATIODETAILSDETAILS).pipe(map((response: any) => response));
  }

  getActiveEbitaDetails() {
    return this.http.get(Api.GETACTIVEEBITADETAILS).pipe(map((response: any) => response));
  }

  getActiveExistingCommitmentDetails() {
    return this.http.get(Api.GETACTIVEEXISTINGCOMMITMENTDETAILS).pipe(map((response: any) => response));
  }

  getActiveTerminationDetails() {
    return this.http.get(Api.GETACTIVETERMINATIONDETAILS).pipe(map((response: any) => response));
  }

  getActiveEarlyCompletionBonusDetails() {
    return this.http.get(Api.GETACTIVEEARLYCOMPLETIONBONUSDETAILS).pipe(map((response: any) => response));
  }

  getActiveTimelyCompletionDetails() {
    return this.http.get(Api.GETACTIVETIMELYCOMPLETIONDETAILS).pipe(map((response: any) => response));
  }

  getActiveEstablishmentYearDetails() {
    return this.http.get(Api.GETACTIVEESTABLISHMENTYEARDETAILS).pipe(map((response: any) => response));
  }

  getActivePermanentStaffDetails() {
    return this.http.get(Api.GETACTIVEPERMANENTSTAFFDETAILS).pipe(map((response: any) => response));
  }

  getActiveIsoDetails() {
    return this.http.get(Api.GETACTIVEISODETAILS).pipe(map((response: any) => response));
  }

  getActiveRecognitionDetails() {
    return this.http.get(Api.GETACTIVERECOGNITIONDETAILS).pipe(map((response: any) => response));
  }

  getActiveDisputesDetails() {
    return this.http.get(Api.GETACTIVEDISPUTEDETAILS).pipe(map((response: any) => response));
  }

  getActiveLegalCaseDetails() {
    return this.http.get(Api.GETACTIVELEGALCASEDETAILS).pipe(map((response: any) => response));
  }

  getEquipmentContactSellerDetail(data) {
    return this.http.post(Api.GET_EQUIPMENT_CONTACT_DETAIL, data).pipe(map((response: any) => response));
  }

  downloadExcel() {
    return this.http.get(Api.DOWNLOAD_PROJECT_EXCEL_DATA, { responseType: "blob" }).pipe(map((response: any) => response));
  }

  downloadExcelId(data) {
    return this.http.get(Api.DOWNLOAD_PROJECT_COMPANYID + '?company=' + data, { responseType: "blob" }).pipe(map((response: any) => response));
  }

  post(obj, url) {
    var mapForm = document.createElement("form");
    mapForm.target = "_blank";
    mapForm.method = "POST"; // or "post" if appropriate
    mapForm.action = url;
    Object.keys(obj).forEach(function (param) {
      var mapInput = document.createElement("input");
      mapInput.type = "hidden";
      mapInput.name = param;
      mapInput.setAttribute("value", obj[param]);
      mapForm.appendChild(mapInput);
    });
    document.body.appendChild(mapForm);
    mapForm.submit();
  }


  getGstDetails() {
    return this.http.get(Api.GET_GST_DETAILS).pipe(map((response: any) => response));
  }

  extendSellerContactLimit(obj, url) {
    var mapForm = document.createElement("form");
    mapForm.target = "_blank";
    mapForm.method = "POST"; // or "post" if appropriate
    mapForm.action = url;
    Object.keys(obj).forEach(function (param) {
      var mapInput = document.createElement("input");
      mapInput.type = "hidden";
      mapInput.name = param;
      mapInput.setAttribute("value", obj[param]);
      mapForm.appendChild(mapInput);
    });
    document.body.appendChild(mapForm);
    mapForm.submit();
  }
  getGetTeamMemberSectorDetails(data) {
    return this.http.post(Api.GET_SECTOR_DETAILS_BY_TEAMEMBERS, data).pipe(map((response: any) => response));
  }

  getActiveProjectDetailsByTeamMembersId(data, size, index) {
    return this.http.post(Api.GET_ACTIVE_PROJECT_DETAILS_BY_TEAMMEMBER + '?page=' + index + '&&size=' + size, data).pipe(map((response: any) => response));
  }
  searchEquipmentsl(data) {
    return this.http.post(Api.SEARCH_EQUIPMENTS_CAT, data).pipe(map((response: any) => response));
  }

  searchSelectedEquipments(data) {
    return this.http.post(Api.SEARCH_SHORT_LISTED, data).pipe(map((response: any) => response));
  }
  searchEquipmentsRequirement(data) {
    return this.http.post(Api.SEARCH_EQUIPMENTS_REQUIREMENT_POSTING, data).pipe(map((response: any) => response));
  }

// -------------------------PLANTS AND EQUIPMENT-------------

  searchPlantsEquipmentInsurance(req) {
    return this.http.post(Api.SEARCHPLANTSEQUIPMENTSINSURANCE, req).pipe(map((response: any) => response));
  }
  
  searchPlantsEquipmentFinance(req) {
    return this.http.post(Api.SEARCHPLANTSEQUIPMENTSFINANCE, req).pipe(map((response: any) => response));
  }
  
  searchProjectInsurance(req) {
    return this.http.post(Api.SEARCHPROJECTINSURANCE, req).pipe(map((response: any) => response));
  }
  searchProjectFinance(req) {
    return this.http.post(Api.SEARCHPROJECTFINANCE, req).pipe(map((response: any) => response));
  }

  
  getActiveProjectsFinance(size, index,data) {
    let req = {
        "isSearch": false,
    };
    return this.http.post(Api.GETACTIVEPROJECTFINANCEBYIDLIST + '?page=' + index + '&&size=' + size,data).pipe(map((response: any) => response));
  }
  
  getActivePlantEquipmentFinance(size, index,data) {
    let req = {
        "isSearch": false,
    };
    return this.http.post(Api.GETACTIVEPLANTEQUIPMENTFINANCEIDLIST + '?page=' + index + '&&size=' + size,data).pipe(map((response: any) => response));
  }

  getActivePlantEquipmentInsurance(size, index,data) {
   
    return this.http.post(Api.GETACTIVEPLANTEQUIPMENTINSURANCEBYIDLIST + '?page=' + index + '&&size=' + size, data).pipe(map((response: any) => response));
  }


  getActiveProjectInsuranceList(size, index) {
    const userID = JSON.parse(localStorage.getItem('loginUserId'));
    let body = {
      user:{userId:userID}
    };
    return this.http.post(Api.GETACTIVEPROJECTINSURANCEBYIDLIST + '?page=' + index + '&&size=' + size, body).pipe(map((response: any) => response));
  }

editProjectInsurance(req){
    return this.http.post(Api.GETACTIVEPROJECTINSURANCEBYIDFORMOBILE, req).pipe(map((response: any) => response));
}

editPlantAndEquipmentInsurance(req){
  return this.http.post(Api.GETACTIVEPLANTEQUIPMENTINSURANCEBYIDFORMOBILE, req).pipe(map((response: any) => response));
}

editProjectFinance(req){
  return this.http.post(Api.GETACTIVEPROJECTFINANCEBYIDFORMOBILE, req).pipe(map((response: any) => response));
}

editPlantAndEquipmentFinance(req){
  return this.http.post(Api.GETPLANTSANDEQUIPMENTFINANCEBYIDFORMOBILE, req).pipe(map((response: any) => response));
}

deleteProjectInsurance(projectInsuranceId) {
  const options = {
        projectInsuranceId: projectInsuranceId,
  };
  return this.http
      .post(Api.DELETEPROJECTINSURANCEBYID, options)
      .pipe(map((response: any) => response));
}
deleteprojectFinance(projectFinanceId) {
  const options = {
    projectFinanceId: projectFinanceId,
  };
  return this.http
      .post(Api.DELETEPROJECTFINANCEBYID, options)
      .pipe(map((response: any) => response));
}
deletePlantsAndEquipmentInsurance(plantsAndEquipmentInsuranceId) {
  const options = {
    plantsAndEquipmentInsuranceId: plantsAndEquipmentInsuranceId,
  };
  return this.http
      .post(Api.DELETEPLANTEQUIPMENTINSURANCEBYID, options)
      .pipe(map((response: any) => response));
}
deletePlantsEquipmentFinace(plantsEquipmentFinaceId) {
  const options = {
    plantsEquipmentFinaceId: plantsEquipmentFinaceId,
  };
  return this.http
      .post(Api.DELETEPLANTEQUIPMENTFINANCEBYID, options)
      .pipe(map((response: any) => response));
}

addWorkTypeToCompany(data){
  return this.http.post(Api.AddWorkTypeToCompany, data).pipe(map((response: any) => response));
}
addWorkTypeToVendor(data){
  return this.http.post(Api.AddWorkTypeToVendor, data).pipe(map((response: any) => response));
}

getWorkTypeDetails(size, index, data) {
  const body = {
    companyId: data 
  };
  return this.http.post(Api.GETACTIVELISTOFWORKTYPEDETAILSBYCOMPANYIDWITHPAGEABLE + '?page=' + index + '&&size=' + size, body).pipe(map((response: any) => response));
}

getWorkTypeDetailsVendor(size, index, data) {
  const body = {
    vendorId: data 
  };
  return this.http.post(Api.GETACTIVELISTOFWORKTYPEDETAILSBYVENDORIDWITHPAGEABLE + '?page=' + index + '&&size=' + size, body).pipe(map((response: any) => response));
}

deleteAllWorkType(companyId) {
  const body = {
    companyId: companyId
  };
  return this.http.post(Api.DELETEALLWORKTYPEOFCOMPANY, body).pipe(map((response: any) => response));
}

deleteAllWorkTypeVendor(vendorId) {
  const body = {
    vendorId: vendorId
  };
  return this.http.post(Api.DELETEALLWORKTYPEOFVENDOR, body).pipe(map((response: any) => response));
}

deleteWorkType(workTypeId) {
  const options = {
      headers: new HttpHeaders({
          "Content-Type": "application/json",
      }),
      body: {
          workTypeId: workTypeId,
      },
  };
  return this.http
  .delete(Api.DELETEWORKTYPEOFCOMPANY, options)
  .pipe(map((response: any) => response));
}

deleteWorkTypeVendor(workTypeId) {
  const options = {
      headers: new HttpHeaders({
          "Content-Type": "application/json",
      }),
      body: {
          workTypeId: workTypeId,
      },
  };
  return this.http
  .delete(Api.DELETEWORKTYPEOFVENDOR, options)
  .pipe(map((response: any) => response));
}

}
